export default __webpack_public_path__ + "static/GDPR_Autoskola_Hron_sro-a85ee1783c8911996bb816b8190299ef.pdf";